export default __webpack_public_path__ + "static/media/icon_R.0eaa51bf.svg";